var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.215,
    cy: 21.2764,
    rx: 20.215,
    ry: 21,
    fill: "#BFE1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 20.1264C10.9117 20.1264 10.3969 20.6412 10.3969 21.2764C10.3969 21.9115 10.9117 22.4264 11.5469 22.4264V20.1264ZM28.7245 22.0895C29.1736 21.6404 29.1736 20.9123 28.7245 20.4632L21.406 13.1446C20.9569 12.6955 20.2287 12.6955 19.7796 13.1446C19.3305 13.5937 19.3305 14.3219 19.7796 14.771L26.285 21.2764L19.7796 27.7817C19.3305 28.2309 19.3305 28.959 19.7796 29.4081C20.2287 29.8572 20.9569 29.8572 21.406 29.4081L28.7245 22.0895ZM11.5469 22.4264H27.9114V20.1264H11.5469V22.4264Z",
    fill: "#0C88ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.de86ec02191f0376aefa1064aeb2361b.svg";
export { ForwardRef as ReactComponent };